<ng-container *ngTemplateOutlet="language === 'en' ? en : fr "></ng-container>

<!--TEMPLATES ENGLISH-->
<ng-template #en>
  <div class="td-wb-preferences__agreement-form">
    <h1 class="td-wb-preferences__agreement-form__header">OPRA Exchange Agreement</h1>
    @if (disabled) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copy for "Viewing Purposes only" :
        No action required, this agreement has been accepted. Thank You.
      </td-wb-notification>
    }
    <p class="td-wb-preferences__agreement-form--copy">Options Price Reporting Authority Electronic Form of Customer Agreement for
      Dial-Up Market Data Service <br>(Option Last Sale and Quotation Information)</p>

      <p class="td-wb-preferences__agreement-form--copy">IMPORTANT NOTICE: THIS IS AN AGREEMENT BETWEEN YOU AND TD WATERHOUSE CANADA
        INC., FOR YOU TO RECEIVE INFORMATION PUBLISHED BY THE OPTIONS PRICE REPORTING AUTHORITY ("OPRA"). PLEASE READ
        THIS AGREEMENT CAREFULLY. AFTER YOU HAVE READ THIS AGREEMENT, PLEASE INDICATE YOUR AGREEMENT TO BE BOUND BY ITS
        TERMS AND CONDITIONS BY CLICKING ON THE "I AGREE" BUTTON AT THE END. IF YOU DO NOT AGREE TO THESE TERMS AND
      CONDITIONS, YOU WILL BE UNABLE TO RECEIVE THE INFORMATION.</p>

      <p class="td-wb-preferences__agreement-form--copy">By completing and submitting this Agreement, you are applying to receive through TD Waterhouse Canada Inc., 77
        Bloor Street West, Toronto, Ontario, M4Y 2T1, (the "Vendor") a dial-up computer or Internet-based market data
        service (the "Service") providing access to current options last sale information, current options quotation
        information and related information ("Options information") published by the Options Pricing Reporting Authority
        ("OPRA") pursuant to a Plan declared effective by the Securities and Exchange Commission. The "OPRA
        Participants" are those national securities exchanges who, from time to time, are parties to this Plan. Those
        persons who act from time to time as data processors on behalf of OPRA are referred to herein as "OPRA's
      Processor".</p>

      <p class="td-wb-preferences__agreement-form--copy">For the purpose of this Agreement, you hereby represent and agree as follows (type in the answers as
      indicated):</p>

      <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
        <li class="td-wb-preferences__agreement-form--primary-item">Your full name and address:
          @if (!disabled) {
            <div>
              <ng-container *ngTemplateOutlet="form"></ng-container>
            </div>
          }
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">You shall receive the Service and the Options Information included therein solely for your own use, and you
          shall not retransmit or otherwise furnish the Options Information to any other person.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">You acknowledge that the options Information is and shall remain the property of the respective exchange or
          other market on which a reported transaction took place or a reported quotation was entered.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item td-wb-preferences__agreement-form--copy-bold">DISCLAIMER OF LIABILTY -- NEITHER TD WATERHOUSE CANADA INC., OPRA, OPRA'S PROCESSOR NOR ANY OPRA
          PARTICIPANT GUARANTEES THE TIMELINESS, SEQUENCE, ACCURACY OR COMPLETENESS OF ANY OF THE OPTIONS INFORMATION
          SUPPLIED TO YOU HEREUNDER AND NEITHER TD WATERHOUSE CANADA INC., OPRA, OPRA'S PROCESSOR NOR ANY OPRA
          PARTICIPANT SHALL BE LIABLE IN ANY WAY TO YOU OR TO ANY OTHER PERSON, FOR ANY LOSS, DAMAGES, COST OR EXPENSE
          WHICH MAY ARISE FROM ANY FAILURE OF PERFORMANCE BY TD WATERHOUSE CANADA INC., OPRA, OPRA'S PROCESSOR OR ANY
          OPRA PARTICIPANT, OR FROM ANY DELAYS, INACCURACIES, ERRORS IN OR OMISSIONS OF, ANY OF THE OPTIONS
          INFORMATION OR IN THE TRANSMISSION OR DELIVERY THEREOF, WHETHER OR NOT DUE TO ANY NEGLIGENT ACT OR OMISSION
          ON THE PART OF TD WATERHOUSE CANADA INC., OPRA, OPRA'S PROCESSOR OR ANY PARTICIPANT. IN NO EVENT SHALL TD
          WATERHOUSE CANADA INC., OPRA, OPRA'S PROCESSOR OR ANY PARTICIPANT BE LIABLE FOR ANY INCIDENTAL, SPECIAL,
          INDIRECT OR CONSEQUENTIAL DAMAGES, INCLUDING BUT NOT LIMITED TO LOST PROFITS, TRADING LOSSES, OR DAMAGES
        RESULTING FROM INCONVENIENCE OR LOSS OF USE OF THE SERVICE.</li>

        <li class="td-wb-preferences__agreement-form--primary-item">The terms and conditions of this Agreement may be modified at any time upon notice to you. If you do not
          assent to the terms of any such modified Agreement at or prior to the time you next attempt to access the
          Service, this Agreement shall automatically be terminated.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Your privilege of receiving the Options Information hereunder may be terminated by you or by Vendor upon 30
          days written notice from the terminating party to the other party, and may be terminated immediately upon a
          determination by Vendor or OPRA that you are not in compliance with this Agreement.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Nothing herein shall be deemed to prevent or restrict OPRA, OPRA's Processor or any OPRA Participant from
          discontinuing to furnish Options Information for the dissemination or from making such changes in the speed
          of transmission, the characteristics to the electrical signals representing the Options Information or the
          manner of disseminating the same, as OPRA shall from time to time determine to be appropriate, with or
          without notice to you. You shall not hold OPRA, OPRA's Processor, or any OPRA Participant liable for any
          resulting liability, loss or damage that may arise therefrom.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">You agree to inform Vendor promptly in writing at its address set forth above of any changes in information
          provided herein and to furnish Vendor any additional information requested by it in connection with your
          receipt of the Options Information.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">The parties acknowledge and agree that this Agreement is for the express benefit of OPRA, OPRA'S Processor
          and each OPRA Participant.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">The Provision of sections 3, 4 and 9 survive any termination of this Agreement and remain in full force and
          effect. IF YOU AGREE TO THE TERMS AND CONDITIONS SET FORTH ABOVE, PLEASE TYPE IN YOUR NAME AND ADDRESS IN
          THE SPACES PROVIDED ABOVE AND CLICK ON THE "I Accept" BUTTON BELOW. By clicking on the "I Accept"
          button below and typing in your name as indicated above, you agree that:
          <ol class="td-wb-preferences__agreement-form--secondary">
            <li class="td-wb-preferences__agreement-form--secondary-item">you have read and you understand all of the terms and conditions set forth above; and</li>
            <li class="td-wb-preferences__agreement-form--secondary-item">you intend to form a legally binding and valid contract under which you will be bound by all the
              terms and conditions set forth above.
            </li>
          </ol>
        </li>
      </ol>
      @if (disabled) {
        <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
          <span>Dated: </span>
          <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
        </p>
      }
    </div>
  </ng-template>

  <!--TEMPLATES FRENCH-->
  <ng-template #fr>
    <div>
      <h1 class="td-wb-preferences__agreement-form__header">Entente de négociation - OPRA</h1>
      @if (disabled) {
        <td-wb-notification class="td-wb-preferences-agreements__completed"
                            notificationType="success">
          Copie pour « À des fins de visualisation seulement » :
          Aucune mesure à prendre, ce contrat a été accepté. Merci.
        </td-wb-notification>
      }
      <p class="td-wb-preferences__agreement-form--copy">Options Price Reporting Authority
        Version électronique du contrat concernant l'accès par réseau commuté aux données de marché
      (renseignements sur les dernières ventes et les dernières cotes des options)</p>

      <p class="td-wb-preferences__agreement-form--copy">AVIS IMPORTANT : LA PRÉSENTE CONSTITUE UN CONTRAT PASSÉ ENTRE VOUS ET TD WATERHOUSE CANADA INC. POUR VOUS PERMETTRE
        DE RECEVOIR DES RENSEIGNEMENTS PUBLIÉS PAR L'OPTIONS PRICE REPORTING AUTHORITY (« OPRA »). VEUILLEZ LIRE LE CONTRAT
        ATTENTIVEMENT. UNE FOIS QUE VOUS AVEZ LU LE CONTRAT, VEUILLEZ SIGNIFIER QUE VOUS EN ACCEPTEZ LES CONDITIONS EN
        CLIQUANT SUR LE BOUTON « JE SUIS D'ACCORD » À LA FIN. SI VOUS N'ACCEPTEZ PAS CES CONDITIONS, VOUS NE POURREZ PAS
      RECEVOIR LES RENSEIGNEMENTS.</p>

      <p class="td-wb-preferences__agreement-form--copy">En remplissant et en transmettant le contrat, vous demandez à TD Waterhouse Canada inc., 77, rue Bloor Ouest,
        Toronto (Ontario) M4Y 2T1 (le « fournisseur ») de vous fournir par accès commuté ou Internet un service de données
        sur les marchés (le « service ») permettant de recevoir au moyen d'un ordinateur les renseignements sur les
        dernières ventes des options en cours, les renseignements sur les cotes des options en cours et d'autres
        renseignements connexes (les « renseignements sur les options ») publiés par l'Options Price Reporting Authority («
        OPRA ») aux termes d'un programme jugé valide par la Securities and Exchange Commission. Les « participants de
        l'OPRA » sont les bourses et associations nationales de valeurs mobilières qui font partie du programme de temps à
        autre. Les personnes qui traitent des données de temps à autre pour le compte de l'OPRA sont appelées le « service
      de traitement de l'OPRA » dans les présentes.</p>

      <p class="td-wb-preferences__agreement-form--copy">Pour les fins du présent contrat, vous déclarez par la présente ce qui
      suit et en convenez (tapez les réponses selon les instructions) :</p>

      <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
        <li class="td-wb-preferences__agreement-form--primary-item">Votre nom au complet et votre adresse :
          @if (!disabled) {
            <div>
              <ng-container *ngTemplateOutlet="form"></ng-container>
            </div>
          }
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Vous recevrez le service et les renseignements sur les options fournis aux termes des présentes uniquement à des
          fins
          personnelles, et ne devrez ni retransmettre ni fournir autrement les renseignements sur les options à quiconque.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Vous reconnaissez que les renseignements sur les options demeurent la propriété de la bourse sur laquelle une
          opération déclarée a eu lieu ou qu'une cote déclarée a été inscrite.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">DÉNI DE RESPONSABILITÉ - NI TD WATERHOUSE CANADA INC., NI L'OPRA, NI LE SERVICE DE TRAITEMENT DE L'OPRA, NI
          TOUT
          PARTICIPANT DE L'OPRA NE GARANTIT L'ACTUALITÉ, LA SÉQUENCE, L'EXACTITUDE OU L'EXHAUSTIVITÉ DES RENSEIGNEMENTS
          SUR
          LES OPTIONS QUI VOUS SONT FOURNIS AUX TERMES DES PRÉSENTES; NI TD WATERHOUSE CANADA INC., NI L'OPRA, NI LE
          SERVICE
          DE TRAITEMENT DE L'OPRA, NI TOUT PARTICIPANT DE L'OPRA N'EST RESPONSABLE D'AUCUNE FAÇON ENVERS VOUS OU TOUTE
          AUTRE
          PERSONNE DES PERTES, DOMMAGES, COÛTS ET DÉPENSES POUVANT DÉCOULER D'UNE INEXÉCUTION DE LA PART DE TD WATERHOUSE
          CANADA INC., DE L'OPRA, DU SERVICE DE TRAITEMENT DE L'OPRA OU DE TOUT PARTICIPANT DE L'OPRA, OU D'UN RETARD,
          D'UNE
          INEXACTITUDE, D'UNE ERREUR OU D'UNE OMISSION RELATIVEMENT AUX RENSEIGNEMENTS SUR LES OPTIONS OU ENCORE AU MOMENT
          DE
          LA LIVRAISON OU DE LA TRANSMISSION DE CES RENSEIGNEMENTS, ATTRIBUABLE OU NON À UNE NÉGLIGENCE OU À UN OUBLI DE
          TD
          WATERHOUSE CANADA INC., DE L'OPRA, DU SERVICE DE TRAITEMENT DE L'OPRA OU DE TOUT PARTICIPANT DE L'OPRA. TD
          WATERHOUSE CANADA INC., L'OPRA, LE SERVICE DE TRAITEMENT DE L'OPRA ET LES PARTICIPANTS DE L'OPRA N'ASSUMENT
          AUCUNE
          RESPONSABILITÉ POUR LES DOMMAGES INDIRECTS, SPÉCIAUX OU ACCESSOIRES, DONT LES PROFITS PERDUS, LES PERTES DE
        NÉGOCIATION ET LES DOMMAGES RÉSULTANT DES INCONVÉNIENTS OU DE LA PERTE D'UTILISATION DU SERVICE.</span></li>

        <li class="td-wb-preferences__agreement-form--primary-item">Vous ou votre fournisseur pouvez mettre fin à votre privilège de recevoir les renseignements sur les options
          moyennant un préavis de 30 jours remis par la partie qui résilie à l'autre partie. Le privilège prend fin dès
          que le fournisseur ou l'OPRA juge que vous ne respectez pas le présent contrat.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Vous ou votre fournisseur pouvez mettre fin à votre privilège de recevoir les renseignements sur les options
          moyennant un préavis de 30 jours remis par la partie qui résilie à l'autre partie. Le privilège prend fin dès
          que le fournisseur ou l'OPRA juge que vous ne respectez pas le présent contrat.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Aucune des dispositions du présent contrat ne peut être considérée comme empêchant l'OPRA, le service de
          traitement de l'OPRA ou tout participant de l'OPRA de cesser de fournir les renseignements sur les options
          destinés à la diffusion ou d'apporter les changements que l'OPRA peut juger utiles à la vitesse de transmission,
          aux caractéristiques des signaux électroniques représentant les renseignements ou à la manière de diffuser les
          renseignements, avec ou sans préavis. Ni l'OPRA, ni le service de traitement de l'OPRA, ni tout participant de
          l'OPRA ne sera tenu responsable des dettes, pertes et dommages pouvant découler de tels changements.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Vous acceptez d'informer le fournisseur sans tarder par écrit à l'adresse mentionnée plus haut de tout changement
          apporté aux renseignements fournis dans les présentes et à transmettre au fournisseur tout autre renseignement
          qu'il pourra demander relativement à votre réception des renseignements sur les options.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Les parties reconnaissent et conviennent que le présent contrat est pour le seul bénéfice de l'OPRA, du service
          de traitement de l'OPRA et de tout participant de l'OPRA.
        </li>

        <li class="td-wb-preferences__agreement-form--primary-item">Les clauses des paragraphes 3, 4 et 9 demeurent pleinement en vigueur après toute résiliation du présent contrat.
          SI VOUS ACCEPTEZ LES CONDITIONS ÉNONCÉES PLUS HAUT, VEUILLEZ TAPER VOTRE NOM ET VOTRE ADRESSE AUX ENDROITS
          PRÉVUS À CETTE FIN, PUIS CLIQUEZ SUR LE BOUTON « J'accepte le contrat » CI-DESSOUS. En cliquant sur le bouton «
          J'accepte le contrat » ci-dessous et en tapant votre nom selon les instructions données plus haut, vous convenez
          que :
          <ol class="td-wb-preferences__agreement-form--secondary">
            <li class="td-wb-preferences__agreement-form--secondary-item">vous avez lu toutes les conditions énoncées plus haut et que vous les comprenez; et que</li>
            <li class="td-wb-preferences__agreement-form--secondary-item">vous avez
              l'intention de conclure un contrat ayant force obligatoire en vertu duquel vous serez lié par toutes les
              conditions énoncées plus haut..
            </li>
          </ol>
        </li>
      </ol>
      @if (disabled) {
        <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
          <span>daté : </span>
          <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
        </p>
      }
    </div>
  </ng-template>

  <!--FORM TEMPLATE-->
  <ng-template #form>
    <td-wb-form class="td-wb-platform td-wb-platform--opra"
      novalidate
      autocomplete="off">
      <td-wb-form-row>
        <div class="td-wb-preferences__agreement-form--input-row">
          <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
            <td-wb-input-group-label>
              <label for="clientFirstName"
                translate="tdWb.platform.preferences.agreements.OPRA.SUBSCRIBER_FIRST_NAME">
              </label>
            </td-wb-input-group-label>
            <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
              <input type="text"
                id="clientFirstName"
                class="td-wb-full-width"
                name="clientFirstName"
                tdWbInput
                [required]="!consolidateAgreement"
                [attr.aria-required]="!consolidateAgreement"
                maxlength="35"
                [disabled]="consolidateAgreement"
                [attr.aria-disabled]="consolidateAgreement"
                [(ngModel)]="formModel.clientFirstName">
                <td-wb-input-errors input="clientFirstName"
                  errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR">
                </td-wb-input-errors>
              </td-wb-input-group-field>
            </td-wb-input-group>
            <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
              <td-wb-input-group-label>
                <label for="clientLastName"
                  translate="tdWb.platform.preferences.agreements.OPRA.SUBSCRIBER_LAST_NAME">
                </label>
              </td-wb-input-group-label>
              <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                <input type="text"
                  id="clientLastName"
                  class="td-wb-full-width"
                  name="clientLastName"
                  tdWbInput
                  [required]="!consolidateAgreement"
                  [attr.aria-required]="!consolidateAgreement"
                  maxlength="35"
                  [disabled]="consolidateAgreement"
                  [attr.aria-disabled]="consolidateAgreement"
                  [(ngModel)]="formModel.clientLastName">
                  <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR">
                  </td-wb-input-errors>
                </td-wb-input-group-field>
              </td-wb-input-group>
            </div>
            <div class="td-wb-preferences__agreement-form--input-row">
              <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
                <td-wb-input-group-label>
                  <label for="addressLine1"
                    translate="tdWb.platform.preferences.agreements.OPRA.SUBSCRIBER_ADDRESS">
                  </label>
                </td-wb-input-group-label>
                <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field td-wb-preferences__agreement-form--input-group-field--address">
                  <input type="text"
                    id="addressLine1"
                    class="td-wb-preferences__agreement-form--input-address"
                    name="addressLine1"
                    tdWbInput
                    [required]="!consolidateAgreement"
                    [attr.aria-required]="!consolidateAgreement"
                    maxlength="30"
                    [disabled]="consolidateAgreement"
                    [attr.aria-disabled]="consolidateAgreement"
                    [(ngModel)]="formModel.addressLine1">
                    <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR">
                    </td-wb-input-errors>

                    <input type="text"
                      id="addressLine2"
                      class="td-wb-preferences__agreement-form--input-address-2"
                      name="addressLine2"
                      tdWbInput
                      maxlength="30"
                      [disabled]="consolidateAgreement"
                      [attr.aria-disabled]="consolidateAgreement"
                      [(ngModel)]="formModel.addressLine2">
                    </td-wb-input-group-field>
                  </td-wb-input-group>
                  <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
                    <td-wb-input-group-label>
                      <label for="city"
                        translate="tdWb.platform.preferences.agreements.OPRA.SUBSCRIBER_CITY">
                      </label>
                    </td-wb-input-group-label>
                    <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                      <input type="text"
                        id="city"
                        class="td-wb-full-width"
                        name="city"
                        tdWbInput
                        [required]="!consolidateAgreement"
                        [attr.aria-required]="!consolidateAgreement"
                        maxlength="30"
                        [disabled]="consolidateAgreement"
                        [attr.aria-disabled]="consolidateAgreement"
                        [(ngModel)]="formModel.city">
                        <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR">
                        </td-wb-input-errors>
                      </td-wb-input-group-field>
                    </td-wb-input-group>
                  </div>
                  <div class="td-wb-preferences__agreement-form--input-row">
                    <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
                      <td-wb-input-group-label>
                        <label id="td-wb-aria-agreement-province-label" for="provinceState"
                          translate="tdWb.platform.preferences.agreements.OPRA.SUBSCRIBER_PROVINCE">
                        </label>
                      </td-wb-input-group-label>
                      <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                        <td-wb-dropdown class="td-wb-dropdown td-wb-full-width"
                          aria-labelledby="td-wb-aria-agreement-province-label"
                          [placeholder]="'tdWb.provincesStates.PLACEHOLDER' | tdWbTranslate"
                          [panelMaxHeight]="256"
                          name="provinceState"
                          id="provinceState"
                          [(ngModel)]="formModel.provinceState"
                          [disabled]="consolidateAgreement"
                          [attr.aria-disabled]="consolidateAgreement"
                          tdWbInput
                          [required]="!consolidateAgreement"
                          [attr.aria-required]="!consolidateAgreement">
                          @for (province of provinceStatesCodesService.provinces.translatedProvinces; track province) {
                            <td-wb-dropdown-item
                              [value]="provinceStatesCodesService.provinces.provinceCodes[province]">
                              <span [translate]="province"></span>
                            </td-wb-dropdown-item>
                          }
                          @for (state of provinceStatesCodesService.states.translatedStates; track state) {
                            <td-wb-dropdown-item
                              [value]="provinceStatesCodesService.states.stateCodes[state]">
                              <span [translate]="state"></span>
                            </td-wb-dropdown-item>
                          }
                          <td-wb-dropdown-item [value]="provinceStatesCodesService.other.otherCountry">
                            <span [translate]="provinceStatesCodesService.other.translatedOtherCountry"></span>
                          </td-wb-dropdown-item>
                        </td-wb-dropdown>
                        <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR">
                        </td-wb-input-errors>
                      </td-wb-input-group-field>
                    </td-wb-input-group>
                    <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
                      <td-wb-input-group-label>
                        <label for="postalCode"
                          translate="tdWb.platform.preferences.agreements.OPRA.SUBSCRIBER_POSTAL_CODE">
                        </label>
                      </td-wb-input-group-label>
                      <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                        <input type="text"
                          id="postalCode"
                          class="td-wb-full-width"
                          name="postalCode"
                          tdWbInput
                          [required]="!consolidateAgreement"
                          [attr.aria-required]="!consolidateAgreement"
                          maxlength="9"
                          [disabled]="consolidateAgreement"
                          [attr.aria-disabled]="consolidateAgreement"
                          [(ngModel)]="formModel.postalCode"
                          [tdWbPostalCodeValidator]="formModel.provinceState">
                          <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR">
                          </td-wb-input-errors>
                        </td-wb-input-group-field>
                      </td-wb-input-group>
                    </div>
                  </td-wb-form-row>
                </td-wb-form>
              </ng-template>
